import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

// Import images directly from src folder
import nextLogo from '../images/Next Logos.png';
import homePhoto from '../images/Home Page Photo.jpg';
import pinkArrow from '../images/Pink Arrow.png';
import navBarIcon from '../images/Nav Bar Icon.png';

const Home = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <main className={styles.mainContainer}>
      {/* NAV - Header */}
      {isLargeScreen ? (
        <Header />
      ) : (
        <header className={styles.header}>
          {/* Next Logos Thumbnail - Header logo */}
          <div className={styles.navBarIcon}></div>
          
          {/* Frame 4 - Navigation container */}
          <nav className={styles.navigation}>
            <ul className={styles.navList}>
              <li><Link to="/about" className={styles.navLink}>ABOUT</Link></li>
              <li><Link to="/team" className={styles.navLink}>TEAM</Link></li>
              <li><Link to="/services" className={styles.navLink}>SERVICES</Link></li>
              <li><Link to="/work" className={styles.navLink}>WORK</Link></li>
              <li><Link to="/connect" className={styles.navLink}>CONNECT</Link></li>
            </ul>
          </nav>
        </header>
      )}
      
      {/* Frame 1 - Right section with image */}
      <div className={styles.rightSection}>
        <div className={styles.backgroundImage}></div>
        <div className={styles.imageOverlay}></div>
      </div>
      
      {/* Next Logos - Main logo */}
      <img src={nextLogo} alt="Next Logos" className={styles.mainLogoImage} />
      
      {/* CTA - Call to action button */}
      <Link to="/work" className={styles.ctaButton} aria-label="Find out why"></Link>
      
      {/* Pink Arrow 1 */}
      <img src={pinkArrow} alt="Pink Arrow" className={styles.pinkArrow} />
      
      {/* Footer - Mobile/Tablet: use shared Footer component */}
      {!isLargeScreen && (
        <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', zIndex: 1000 }}>
          <Footer />
        </div>
      )}
    </main>
  );
};

export default Home; 